'use strict';

const UNKNOWN_ERROR = 520;
const JSON_PARSING_FAILED_BLOB_ERROR = "JSON_PARSING_FAILED_BLOB_ERROR";
var HttpErrorType = /* @__PURE__ */ ((HttpErrorType2) => {
  HttpErrorType2["Unauthorized"] = "Unauthorized";
  HttpErrorType2["FfaUnauthorized"] = "FfaUnauthorized";
  HttpErrorType2["IpBlockedAllFeature"] = "IpBlockedAllFeature";
  HttpErrorType2["IpBlockedRoles"] = "IpBlockedRoles";
  HttpErrorType2["Forbidden"] = "Forbidden";
  return HttpErrorType2;
})(HttpErrorType || {});
var CustomErrorType = /* @__PURE__ */ ((CustomErrorType2) => {
  CustomErrorType2["RouteChangeCanceled"] = "RouteChangeCanceled";
  CustomErrorType2["AccessTokenTypeError"] = "AccessTokenTypeError";
  CustomErrorType2["ServerError"] = "ServerError";
  CustomErrorType2["Unknown"] = "Unknown";
  return CustomErrorType2;
})(CustomErrorType || {});
const RESERVED_ERROR_CODE = {
  UNAUTHORIZED: "AUTH_401_000",
  UNAUTHORIZED_FFA: "AUTH_401_407",
  FORBIDDEN: "AUTHZ_403_000",
  /**
   * See: https://flex-cv82520.slack.com/archives/CS05YNN9H/p1720768431285059
   *
   * @deprecated 인가 개편 과정에서 PERM -> AUTHZ 로 변경, LEGACY 코드는 BE에서 오지 않을 것.
   * */
  FORBIDDEN_LEGACY: "PERM_403_000",
  IP_ALL_FEATURES: "ACCESS_403_000",
  /** @deprecated 근무지 제한 개선 bet item에서 없어짐 */
  IP_SPECIFIC_FEATURE: "ACCESS_403_100"
};
const NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES = [
  "Unauthorized" /* Unauthorized */,
  "IpBlockedAllFeature" /* IpBlockedAllFeature */,
  "IpBlockedRoles" /* IpBlockedRoles */
];
const PEOPLE_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = [
  "UPAP_400_001"
  // 입력하신 인사 정보가 발령일 직전의 정보와 동일합니다. (people)
];
const TODO_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = [
  "WORKFLOW_400_005"
  // 이미 처리가 완료된 건입니다.
];
const AUTH_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = [
  "AUTH_400_000",
  // 올바른 요청이 아닙니다. 처음부터 다시 시도해 주세요. (리프레시 토큰 만료)
  "AUTH_400_100",
  // 비밀번호가 일치하지 않습니다
  "AUTH_400_104",
  // 비밀번호를 잘못 입력했어요. (2FA 인증 실패)
  "AUTH_400_400",
  // 안전하지 않은 비밀번호입니다.
  "AUTH_404_020",
  // 인증 세션이 만료되었어요. 다시 로그인을 시도해 주세요
  "AUTH_404_100",
  // 계정이 존재하지 않습니다
  "AUTH_404_200",
  // 계정이 존재하지 않습니다 (oAuth)
  "OBUS_400_004"
  // 이미 사용중인 이메일 주소입니다.
];
const NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = [
  ...AUTH_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES,
  ...PEOPLE_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES,
  ...TODO_NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES
];
var CustomHttpHeaderType = /* @__PURE__ */ ((CustomHttpHeaderType2) => {
  CustomHttpHeaderType2["FlexTeamErrorCode"] = "flexteam-errorcode";
  return CustomHttpHeaderType2;
})(CustomHttpHeaderType || {});

exports.CustomErrorType = CustomErrorType;
exports.CustomHttpHeaderType = CustomHttpHeaderType;
exports.HttpErrorType = HttpErrorType;
exports.JSON_PARSING_FAILED_BLOB_ERROR = JSON_PARSING_FAILED_BLOB_ERROR;
exports.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES;
exports.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES = NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES;
exports.RESERVED_ERROR_CODE = RESERVED_ERROR_CODE;
exports.UNKNOWN_ERROR = UNKNOWN_ERROR;
//# sourceMappingURL=constants.cjs.map
